class FrameOptionsCentered extends HTMLElement {
  connectedCallback() {
    this.slideImageGroups = this.querySelectorAll('.slide-images');
    this.slideContentGroups = this.querySelectorAll('.slide-content');
    this.dots = this.querySelectorAll('.slide-dot');
    this.tabs = this.querySelectorAll('.slide-tab');
    this.prevBtn = this.querySelector('.slide-prev');
    this.nextBtn = this.querySelector('.slide-next');
    this.currentSlide = 0;

    this.prevBtn?.addEventListener('click', () => this.goToSlide(this.currentSlide - 1));
    this.nextBtn?.addEventListener('click', () => this.goToSlide(this.currentSlide + 1));

    for (const dot of this.dots) {
      dot.addEventListener('click', () => this.goToSlide(Number(dot.dataset.slideIndex)));
    }

    for (const tab of this.tabs) {
      tab.addEventListener('click', () => this.goToSlide(Number(tab.dataset.slideIndex)));
    }

    this.addEventListener('click', (e) => {
      const swatch = e.target.closest('.frame-swatch');
      if (swatch) this.selectFrame(swatch);
    });

    if (this.slideContentGroups.length > 0) this.goToSlide(0);
  }

  goToSlide(index) {
    const count = this.slideContentGroups.length;
    if (count === 0) return;

    if (index < 0) index = count - 1;
    if (index >= count) index = 0;
    this.currentSlide = index;

    for (const el of this.slideImageGroups) {
      el.style.display = Number(el.dataset.slideIndex) === index ? '' : 'none';
    }

    for (const el of this.slideContentGroups) {
      el.style.display = Number(el.dataset.slideIndex) === index ? '' : 'none';
    }

    for (const dot of this.dots) {
      const isActive = Number(dot.dataset.slideIndex) === index;
      dot.classList.toggle('bg-gray-900', isActive);
      dot.classList.toggle('bg-gray-300', !isActive);
    }

    for (const tab of this.tabs) {
      const isActive = Number(tab.dataset.slideIndex) === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    // Auto-select first frame of active slide
    const activeContent = this.slideContentGroups[index];
    const swatchContainer = activeContent?.querySelector('.slide-swatches');
    const firstSwatch = swatchContainer?.querySelector('.frame-swatch');

    if (firstSwatch) {
      this.selectFrame(firstSwatch);
    } else {
      // Single-frame slide without swatches: show the only image + details
      const slideImgs = this.slideImageGroups[index];
      const singleImage = slideImgs?.querySelector('.frame-image');
      if (singleImage) singleImage.style.display = '';

      const singleDetail = activeContent?.querySelector('.frame-details');
      if (singleDetail) singleDetail.style.display = '';
    }
  }

  selectFrame(swatch) {
    const blockId = swatch.dataset.blockId;
    const slideContent = swatch.closest('.slide-content');
    if (!slideContent) return;

    const slideIndex = slideContent.dataset.slideIndex;

    for (const s of slideContent.querySelectorAll('.frame-swatch')) {
      const circle = s.querySelector('.frame-swatch__circle');
      if (!circle) continue;
      circle.classList.toggle('ring-primary', s.dataset.blockId === blockId);
      circle.classList.toggle('ring-transparent', s.dataset.blockId !== blockId);
    }

    const slideImgs = this.querySelector(`.slide-images[data-slide-index="${slideIndex}"]`);

    if (slideImgs) {
      for (const img of slideImgs.querySelectorAll('.frame-image')) {
        img.style.display = img.dataset.blockId === blockId ? '' : 'none';
      }
    }

    for (const detail of slideContent.querySelectorAll('.frame-details')) {
      detail.style.display = detail.dataset.blockId === blockId ? '' : 'none';
    }
  }
}

customElements.define('frame-options-centered', FrameOptionsCentered);
